import script from "./contant.vue?vue&type=script&lang=js"
export * from "./contant.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__